import { DISPLAY_TIME_ZONE, LOCALE } from './primitives.js';
/**
 * Display words and formatting shared by web and admin, so the two never word
 * or format the same value differently. Plain data and Intl only.
 */
export const PROVINCE_LABELS = {
    EASTERN_CAPE: 'Eastern Cape',
    FREE_STATE: 'Free State',
    GAUTENG: 'Gauteng',
    KWAZULU_NATAL: 'KwaZulu-Natal',
    LIMPOPO: 'Limpopo',
    MPUMALANGA: 'Mpumalanga',
    NORTH_WEST: 'North West',
    NORTHERN_CAPE: 'Northern Cape',
    WESTERN_CAPE: 'Western Cape',
};
export const LIVING_SITUATION_LABELS = {
    OWN: 'I own my home',
    RENTING: "I'm renting",
    OTHER: 'Something else',
};
export const HEARD_FROM_LABELS = {
    WORD_OF_MOUTH: 'Word of mouth',
    SOCIAL_MEDIA: 'Social media',
    MARKETING: 'An advert or promotion',
    OTHER: 'Somewhere else',
};
export const CONSENT_KIND_LABELS = {
    TERMS: 'Terms and conditions',
    PRIVACY: 'Privacy policy',
    MARKETING: 'Offers and news',
    CONTACT_SHARE: 'Sharing contact details',
};
export const PROVIDER_KIND_LABELS = {
    SERVICE: 'Service provider',
    ESTATE_AGENT: 'Estate agent',
    ATTORNEY: 'Attorney',
};
export const PROVIDER_STATUS_LABELS = {
    DRAFT: 'Draft',
    PENDING_REVIEW: 'Waiting for review',
    CHANGES_REQUESTED: 'Changes requested',
    APPROVED: 'Approved',
    REJECTED: 'Not approved',
    UNDER_INVESTIGATION: 'Under investigation',
    PENDING_REMOVAL: 'Pending removal',
    REMOVED: 'Removed',
};
/** What a member sees about their own membership, not the billing word. */
export const SUBSCRIPTION_STATUS_LABELS = {
    PENDING: 'Payment pending',
    TRIALING: 'Free trial',
    ACTIVE: 'Active',
    PAST_DUE: 'Payment due',
    CANCELLED: 'Lapsed',
    EXPIRED: 'Lapsed',
};
/** Said from the member's side: it is their request and their job. */
export const JOB_STATUS_LABELS = {
    REQUESTED: 'Waiting for a reply',
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined',
    EXPIRED: 'No reply',
    VERIFIED: 'Verified',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};
/** The back office calls a suspension a ban, the word on its action. */
export const USER_STATUS_LABELS = {
    ACTIVE: 'Active',
    SUSPENDED: 'Banned',
    DELETED: 'Deleted',
};
/** Dates are stored UTC and shown in Africa/Johannesburg. */
export function formatDate(date, options = {}) {
    return new Intl.DateTimeFormat(LOCALE, {
        timeZone: DISPLAY_TIME_ZONE,
        day: 'numeric',
        month: 'long',
        ...options,
    }).format(date);
}
/**
 * +27821234567 as 082 123 4567, the way South Africans write their numbers.
 * Anything that is not a +27 mobile or landline number comes back unchanged.
 */
export function formatPhone(e164) {
    const match = /^\+27(\d{2})(\d{3})(\d{4})$/.exec(e164);
    if (match === null)
        return e164;
    const [, area, middle, last] = match;
    return `0${area} ${middle} ${last}`;
}
//# sourceMappingURL=display.js.map